import React from 'react';

interface Props {
	size: number;
}

export const SocialScienceIcon: React.FC<Props> = props => (
	<svg
		aria-hidden='true'
		height={props.size}
		viewBox='0 0 24 24'
		width={props.size}
		xmlns='http://www.w3.org/2000/svg'
	>
		<title>socialScience</title>
		<path d='M10.26 20.52A3.3 3.3 0 017 17.23V17H1.55a1 1 0 01-1-1V4.45a1 1 0 011-1h4.79v.42a2.26 2.26 0 000 .26 3.67 3.67 0 107.34 0V3.45h4.79a1 1 0 011 1V7h.22a3.3 3.3 0 110 6.5h-.22v2.59a1 1 0 01-1 1h-4.91v.19a3.3 3.3 0 01-3.3 3.24zM1.55 4.27a.19.19 0 00-.19.18v11.61a.19.19 0 00.19.19h6.2v1a2.51 2.51 0 005 0v-1h5.62a.18.18 0 00.18-.19v-3.52l1.14.19a3 3 0 00.42 0 2.51 2.51 0 100-5 3 3 0 00-.42 0L18.57 8V4.45a.18.18 0 00-.18-.18h-4a4.46 4.46 0 01-8.92 0z' />
	</svg>
);
